<div *ngIf="!hidden"
     style="position: relative;"
     [ngStyle]="{'width': width?width:'100%'}">
    <!--
    CAMPI VISUALIZZATI IN SOLA LETTURA 
    - [grid] SENZA LABEL E SENZA CONTORNO, COME AVVIENE ALL'INTERNO DI UN DATAGRID
    - [card] CON LABEL SOPRA, COME AVVIENE IN UNA CARD
    -->
    <ng-container *ngIf="['grid','card'].includes(mode)">
        <div *ngIf="mode=='card'" class="card-label">{{label|translate}}</div>
        <div class="layout horizontal left middle" style="width: 100%; height: 50px;" [ngStyle]="{'margin-bottom': mode=='card'?'6px':null, color: Color.main}">
            <!--
            STRING, ALPHA_STRING, EMAIL, 'TEXT_AREA', 'DATE', 'TIME'
            -->
            <div class="grid-field" *ngIf="['STRING','ALPHA_STRING','EMAIL','PHONE','TEXT_AREA','DATE','TIME','DATETIME','DATETIME_DOWN_TO_SECONDS','DATETIME_DOWN_TO_MILLIS'].includes(type)">
                {{formatFormField()}}
            </div>
            <!--
            NUMBER, INTEGER, AMOUNT, YEAR
            -->
            <div class="grid-field" *ngIf="['NUMBER','INTEGER','AMOUNT','YEAR'].includes(type)" align="right">
                {{formatFormField()}}
            </div>
            <!--
            BOOLEAN
            -->
            <div class="grid-field layout horizontal left middle" *ngIf="['BOOLEAN'].includes(type)" 
                style="height: 40px; width: 40px;">
                <mat-icon [ngStyle]="{'color': value==true?'green':'red'}">
                    {{value==true ? 'check' : 'clear'}}
                </mat-icon>
            </div>
            <!--
            OPTION
            -->
            <div class="grid-field" *ngIf="['OPTION'].includes(type)">
                <ng-container *ngIf="value && selectableOptionsMap[value+'']">
                    <span *ngIf="!selectableOptionsMap[value+''].icon">
                        {{selectableOptionsMap[value+''].shortLabel}}
                    </span>
                    <div *ngIf="selectableOptionsMap[value+''].icon"
                         class="layout horizontal left middle">
                        <app-icon [id]="selectableOptionsMap[value+''].icon" size="24"></app-icon>
                        <span style="margin-inline-start: 4px;">{{selectableOptionsMap[value+''].shortLabel}}</span>
                    </div>
                </ng-container>
            </div>
            <!--
            MULTI_OPTION
            -->
            <ng-container *ngIf="['MULTI_OPTION'].includes(type)">
                <div *ngIf="!aggregate" class="grid-field" >
                    <span *ngFor="let item of value; let i=index">
                        <span *ngIf="i>0">, </span>
                        {{selectableOptionsMap[item+''] ? selectableOptionsMap[item+''].shortLabel : ''}}
                    </span>
                </div>
                <div *ngIf="aggregate" class="grid-field" align="right">
                    {{value ? formatInteger(asArray(value).length) : 0}}
                     <!-- Con tabindex="-1" si evita che il campo venga selezionato alla pressione del tab-->
                    <button mat-icon-button 
                            tabindex="-1" 
                            (click)="eventStopper($event)"
                            [matMenuTriggerFor]="details"
                            [disabled]="!value || asArray(value).length == 0">
                        <mat-icon style="color: #757575;"
                                  [ngStyle]="{'color': !value || asArray(value).length == 0 ? '#bdbdbd': null}">
                            visibility
                        </mat-icon>
                    </button>
                    <mat-menu #details="matMenu">
                        <ng-container *ngFor="let item of value; let i=index">
                            <div class="layout horizontal left middle" style="height: 32px; padding: 0 8px;">
                                {{selectableOptionsMap[item+''] ? selectableOptionsMap[item+''].shortLabel : ''}}
                            </div>
                        </ng-container>
                    </mat-menu>
                </div>
            </ng-container>
            <!--
            LIST
            -->
            <ng-container *ngIf="['LIST'].includes(type)">
                <div *ngIf="!aggregate" class="grid-field" >
                    <span *ngFor="let item of value; let i=index">
                        <span *ngIf="i>0">, </span>
                        {{item}}
                    </span>
                </div>
                <div *ngIf="aggregate" class="grid-field" align="right">
                    {{value ? formatInteger(asArray(value).length) : 0}}
                     <!-- Con tabindex="-1" si evita che il campo venga selezionato alla pressione del tab-->
                    <button mat-icon-button 
                            tabindex="-1" 
                            (click)="eventStopper($event)"
                            [matMenuTriggerFor]="details"
                            [disabled]="!value || asArray(value).length == 0">
                        <mat-icon style="color: #757575;"
                                  [ngStyle]="{'color': !value || asArray(value).length == 0 ? '#bdbdbd': null}">
                            visibility
                        </mat-icon>
                    </button>
                    <mat-menu #details="matMenu">
                        <ng-container *ngFor="let item of value; let i=index">
                            <div class="layout horizontal left middle" style="height: 32px; padding: 0 8px;">
                                {{item}}
                            </div>
                        </ng-container>
                    </mat-menu>
                </div>
            </ng-container>
            <!--
            IMAGE, AVATAR
            -->
            <div class="grid-field" *ngIf="['IMAGE', 'AVATAR'].includes(type)">
                <img [src]="value" width="100%" [ngClass]="{'avatar': 'AVATAR'==type,
                                                            'image': 'IMAGE'==type}">
            </div>
            <!--
            FILE
            -->
            <div class="grid-field" *ngIf="['FILE'].includes(type)" style="width: 100%">
                <div class="layout horizontal left middle" style="width: 100%">
                    <div class="file-card-field">{{value ? asFile(value).name : null}}</div>
                    <!-- Con tabindex="-1" si evita che il campo venga selezionato alla pressione del tab-->
                    <div style="position: relative; width: 40px; height: 40px;">
                        <div style="position: absolute; top:0; right: -6px;">
                            <app-button [type]="'icon'" 
                                        [icon]="'eye'"
                                        [action]="showFilePreview.bind(this)"
                                        [settings]="{fontColor: !value || asArray(value).length == 0 ? '#bdbdbd': null}">
                             </app-button>
                        </div>
                    </div>
                </div>
            </div>
            <!--
            CHECKBOX
            -->
            <div class="grid-field" *ngIf="['CHECKBOX'].includes(type)">
                {{value?('YES'|translate):('NO'|translate)}}
            </div>
        </div>
        <div *ngIf="!value" style="position: relative;">
            <div style="position: absolute; top: -40px; color: #999;">{{settings.placeholder}}</div>
        </div>
    </ng-container>
    <!--
    CAMPI VISUALIZZATI CON LABEL E CON CONTORNO, COME AVVIENE ALL'INTERNO DI UN FORM
    -->
    <ng-container *ngIf="!['grid','card'].includes(mode)">
        <!--DEBUG ONLY-->
        <div *ngIf="formFieldDataService.DEBUG_MODE" style="border: 1px solid red;">
            <b>STATO FORM FIELD</b><br>
            <i>- VALUE:</i><pre>{{value|json}}</pre>
            <i>- CANDIDATE VALUE:</i><pre>{{candidateValue|json}}</pre>
            <i>- DATE PICKER VALUE:</i><pre>{{datePickerValue|json}}</pre>
        </div>
        
        <!--
        STRING, ALPHA_STRING, EMAIL, PHONE
        -->
        <ng-container *ngIf="['STRING','ALPHA_STRING','EMAIL','PHONE'].includes(type)">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField
                    [placeholder]="settings.placeholder ? (settings.placeholder | translate) : null"
                    [ngModel]="value"
                    [disabled]="readOnly"
                    (focus)="onFormFieldFocus()"
                    (blur)="onFormFieldBlur()"
                    (keydown)="onFormFieldInputChange($event)"
                    (drop)="onFormFieldInputChange($event)"
                    (keydown.enter)="emitEnterPressure()">
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        PASSWORD
        -->
        <ng-container *ngIf="type=='PASSWORD'">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField
                    [type]="passwordHidden ? 'password' : 'text'"
                    [ngModel]="value" 
                    [disabled]="readOnly"
                    (focus)="onFormFieldFocus()"
                    (blur)="onFormFieldBlur()"
                    (keydown)="onFormFieldInputChange($event)"
                    (drop)="onFormFieldInputChange($event)"
                    (keydown.enter)="emitEnterPressure()">
                    <button matSuffix mat-icon-button 
                            [disabled]="readOnly"
                            tabindex="-1">
                        <!-- Gestire parametro showPasswordMode --> 
                        <!-- <mat-icon style="color: #757575;"
                                [ngStyle]="{'font-size': appearance=='legacy'?'18px':null}"
                                (mousedown)="passwordHidden=false"
                                (mouseup)="passwordHidden=true"
                                (mouseleave)="passwordHidden=true">{{passwordHidden ? 'visibility_off' : 'visibility'}}</mat-icon> -->
                            <mat-icon style="color: #757575;"
                                      (mousedown)="passwordHidden=!passwordHidden">{{passwordHidden ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        TEXT_AREA
        -->
        <ng-container *ngIf="type=='TEXT_AREA'">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <textarea matInput #inputFormField rows="3" style="resize: none;"
                    [ngModel]="value" 
                    [disabled]="readOnly"
                    (focus)="onFormFieldFocus()"
                    (blur)="onFormFieldBlur()"
                    (keydown)="onFormFieldInputChange($event)"
                    (drop)="onFormFieldInputChange($event)"
                    (keydown.enter)="emitEnterPressure()">
                </textarea>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        NUMBER, INTEGER, AMOUNT
        -->
        <ng-container *ngIf="['NUMBER','INTEGER','AMOUNT'].includes(type)">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField
                    [ngStyle]="{'text-align': mode=='filter'?'right':'left'}"
                    [ngModel]="formatFormField()"
                    [disabled]="readOnly"
                    (focus)="onFormFieldFocus()" 
                    (blur)="onFormFieldBlur()"
                    (keydown)="onFormFieldInputChange($event)"
                    (drop)="onFormFieldInputChange($event)"
                    (keydown.enter)="emitEnterPressure()">
                    <div class="layout vertical center middle" style="position: absolute; right: -4px; top: -8px;">
                        <app-icon [size]="24" id="chevron-up" style="cursor: pointer;" (click)="onNumberPickerUp()"></app-icon>
                        <app-icon [size]="24" id="chevron-down" style="cursor: pointer;" (click)="onNumberPickerDown()"></app-icon>
                    </div>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        DATE
        -->
        <ng-container *ngIf="type=='DATE'">
            <!--Questo input field è nascosto e serve per raccogliere il valore selezionato tramite date picker
                (non può essere hidden perchè il picker deve aprirsi rispetto alla sua posizione)
                Con tabindex="-1" si evita che il campo venga selezionato alla pressione del tab
            -->
            <input matInput 
                tabindex="-1"
                style="width: 0; height: 0"
                [matDatepicker]="myDatepicker"
                [(ngModel)]="datePickerValue" 
                (dateChange)="onDatePickerChange($event)">
            <mat-form-field appearance="outline"
                            style="width: 100%"  
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField [textMask]="getDateMask()" 
                    [ngModel]="formatFormField()"
                    [disabled]="readOnly" 
                    (focus)="onFormFieldFocus()" 
                    (blur)="onFormFieldBlur()"
                    (keydown)="onFormFieldInputChange($event)"
                    (drop)="onFormFieldInputChange($event)"
                    (keydown.enter)="emitEnterPressure()">
                <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #myDatepicker></mat-datepicker>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        TIME
        -->
        <ng-container *ngIf="type=='TIME'">
            <mat-form-field appearance="outline"
                            style="width: 100%"  
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField [textMask]="getTimeMask()" 
                    [ngModel]="formatFormField()"
                    [disabled]="readOnly" 
                    (focus)="onFormFieldFocus()" 
                    (blur)="onFormFieldBlur()"
                    (keydown)="onFormFieldInputChange($event)"
                    (drop)="onFormFieldInputChange($event)"
                    (keydown.enter)="emitEnterPressure()">
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        DATETIME
        -->
        <ng-container *ngIf="type=='DATETIME'">
            <!--Questo input field è nascosto e serve per raccogliere il valore selezionato tramite date picker
                (non può essere hidden perchè il picker deve aprirsi rispetto alla sua posizione)
                Con tabindex="-1" si evita che il campo venga selezionato alla pressione del tab
            -->
            <input matInput 
                tabindex="-1"
                style="width: 0; height: 0" 
                [matDatepicker]="myDatepicker"
                [(ngModel)]="datePickerValue" 
                (dateChange)="onDatePickerChange($event)">
            <mat-form-field appearance="outline"
                            style="width: 100%"  
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField [textMask]="getDatetimeMask()" 
                    [ngModel]="formatFormField()"
                    [disabled]="readOnly" 
                    (focus)="onFormFieldFocus()" 
                    (blur)="onFormFieldBlur()"
                    (keydown)="onFormFieldInputChange($event)"
                    (drop)="onFormFieldInputChange($event)"
                    (keydown.enter)="emitEnterPressure()">
                <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #myDatepicker></mat-datepicker>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        IMAGE
        -->
        <ng-container *ngIf="['IMAGE'].includes(type)">
            <!--Questo input field è nascosto e serve solo per sfruttare il meccanismo di upload
                dell'html. Graficamente viene pilotato attraferso un input type text con un bottone
            -->
            <input type="file" #file hidden
                   accept="image/*"
                   (change)="onFileSelected($event)"
                   (focus)="onFormFieldFocus()"
                   (blur)="onFormFieldBlur()"
                   (drop)="onFormFieldInputChange($event)">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField
                       [ngModel]="value? asFile(value).name : null" 
                       [disabled]="readOnly"
                       (click)="file.click()"
                       (keydown)="onFileUploadKeyDown($event); file.click()">
                    <!--Bottone per scegliere l'immagine
                        Compare solo se non è ancora stata scelta un'immagine
                    -->
                    <button matSuffix mat-icon-button *ngIf="!value"
                            [disabled]="readOnly"
                            tabindex="-1"
                            (click)="file.click()">
                        <mat-icon style="color: #757575;">
                            add_photo_alternate
                        </mat-icon>
                    </button>
                    <!--Bottone per rimuovere l'immagine caricata
                        Compare solo se è già stata scelta un'immagine
                    -->
                    <button matSuffix mat-icon-button *ngIf="value"
                            tabindex="-1"
                            (click)="clearFile()">
                        <mat-icon style="color: #757575;">
                            clear
                        </mat-icon>
                    </button>
                    <!--Bottone per vedere la preview
                        Compare solo se è già stata scelta un'immagine
                    -->
                    <button matSuffix mat-icon-button *ngIf="value"
                            tabindex="-1"
                            (click)="eventStopper($event)"
                            [matMenuTriggerFor]="preview">
                        <mat-icon style="color: #757575;">
                            visibility
                        </mat-icon>
                    </button>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
            <mat-menu #preview="matMenu">
                <div style="width: 180px; height: 180px; 
                            background-repeat: no-repeat;
                            background-position: center;
                            background-size: contain;"
                     [ngStyle]="{'background-image': 'url(' + value + ')'}"></div>
            </mat-menu>
            <!-- <app-croppie [imgUrl]="value"></app-croppie> -->
        </ng-container>
        <!--
        FILE
        -->
        <ng-container *ngIf="['FILE'].includes(type)">
            <!--Questo input field è nascosto e serve solo per sfruttare il file-picker del browser.
                Il file-picker viene aperto in seguito all'evento file.click(), dove "file" è questo input.
                Siccome questo input è nascosto e quindi non clickabile, file.click() viene scatenato programmaticamente quando si interagisce con l'input text non fittizio e con il bottoncino in esso contenuto
            -->
            <input type="file" #file hidden
                   [multiple] = settings.multipleFileSelection
                   (change)="onFileSelected($event)"
                   (focus)="onFormFieldFocus()"
                   (blur)="onFormFieldBlur()"
                   (drop)="onFormFieldInputChange($event)">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField
                       [ngModel]="value && asArray(value).length ? asFile(asArray(value)[0]).name+'...' : value ? asFile(value).name : null" 
                       [disabled]="readOnly"
                       (click)="file.click()"
                       (focus)="onFormFieldFocus();"
                       (blur)="onFormFieldBlur()"
                       (keydown)="onFormFieldInputChange($event); file.click()"
                       (drop)="onFormFieldInputChange($event); file.click()"
                       (keydown.enter)="emitEnterPressure()">
                <!--Bottone di upload
                    Compare solo se non è ancora stato scelto un file
                -->
                <button matSuffix mat-icon-button *ngIf="!value"
                        [disabled]="readOnly"
                        tabindex="-1"
                        (click)="file.click()">
                    <mat-icon style="color: #757575;">publish</mat-icon>
                </button>
                <!--Bottone per vedere la preview
                    Compare solo se è già stato scelto un file
                -->
                <button matSuffix mat-icon-button *ngIf="value"
                        tabindex="-1"
                        (click)="eventStopper($event); showFilePreview()">
                    <mat-icon style="color: #757575;">visibility</mat-icon>
                </button>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        LOV
        -->
        <ng-container *ngIf="['LOV'].includes(type)">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <input matInput #inputFormField
                       [ngModel]="(value && selectableOptionsMap[value+'']) ? selectableOptionsMap[value+''].shortLabel : ''"  
                       [disabled]="readOnly"
                       (click)="onLovOpen($event)"
                       (keydown)="onLovOpen($event)">
                <!--Bottone di upload
                    Compare solo se non è ancora stato scelto un file
                -->
                <div matSuffix style="width: 40px; height: 40px; color: #757575;" class="layout horizontal center middle">
                    <app-icon [size]="20" id="lov" style="cursor: pointer;" (click)="onLovOpen($event)"></app-icon>
                </div>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        OPTION
        -->
        <ng-container *ngIf="type=='OPTION'">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <mat-select #selectFormField
                            [ngModel]="value"
                            (ngModelChange)="onMatSelectModelChange($event)"
                            [disabled]="readOnly"
                            (focus)="onFormFieldFocus()" 
                            (blur)="onFormFieldBlur()">
                    <mat-option>{{'FORM.NONE'|translate}}</mat-option>
                    <mat-option *ngFor="let selectableOption of selectableOptions" 
                                [value]="selectableOption.id"
                                >{{selectableOption.label}}</mat-option>
                </mat-select>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        MULTI_OPTION
        -->
        <ng-container *ngIf="type=='MULTI_OPTION'">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <mat-select #selectFormField multiple
                            [ngModel]="value"
                            (ngModelChange)="onMatSelectModelChange($event)"
                            [disabled]="readOnly"
                            (focus)="onFormFieldFocus()" 
                            (blur)="onFormFieldBlur()">
                    <mat-option *ngFor="let selectableOption of selectableOptions" 
                                [value]="selectableOption.id"
                                >{{selectableOption.label}}</mat-option>
                </mat-select>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        CHIPS
        -->
        <ng-container *ngIf="type=='CHIPSET'">
            <mat-form-field appearance="outline"
                            style="width: 100%" 
                            [ngClass]="{'error': error && toBeValidated, 'filter': mode=='filter'}">
                <mat-label>{{label|translate}}<span *ngIf="required">*</span></mat-label>
                <mat-chip-list #chipList [disabled]="readOnly">
                    <mat-chip *ngFor="let selectedOptionId of value; index as i"
                            [selectable]="true"
                            [removable]="true"
                            (removed)="remove(selectedOptionId)">
                        {{selectableOptionsMap[selectedOptionId] ? selectableOptionsMap[selectedOptionId].shortLabel : ''}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input #inputFormField
                        [formControl]="chipInputFormControl"
                        [matAutocomplete]="autocomplete"
                        [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="[ENTER, COMMA]"
                        [matChipInputAddOnBlur]="true"
                        (matChipInputTokenEnd)="inputTokenEnd($event)"
                        (drop)="onChipsInputDrop($event)"
                        (focus)="onFormFieldFocus()"
                        (blur)="onFormFieldBlur()"
                        style="width: 100%;">
                </mat-chip-list>
                <!-- 
                AUTOCOMPLEATING LISTBOX
                -->
                <mat-autocomplete #autocomplete="matAutocomplete" 
                                (optionSelected)="selected($event)">
                    <mat-option *ngFor="let item of filteredItems | async" [value]="item">
                        {{item.label}}
                    </mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint>
            </mat-form-field>
        </ng-container>
        <!--
        CHECKBOX_GROUP
        -->
        <ng-container *ngIf="type=='CHECKBOX_GROUP'">
            <div class="fieldset" 
                [ngClass]="{'outline': true, 'selected': editMode}">
                <span class="floating-label"
                    [ngClass]="{'outline': true, 
                                'selected': editMode}">
                    {{label|translate}}
                </span>
                <div class="items-container" 
                    [ngClass]="{'outline': true}">
                    <div *ngFor="let selectableOption of selectableOptions">
                        <mat-checkbox [checked]="isCheckboxChecked(selectableOption)"
                                      (change)="onOptionChange(selectableOption.id)"
                                      (focusin)="onFormFieldFocus()"
                                      (focusout)="onFormFieldBlur()"
                                      [disabled]="readOnly">
                            {{selectableOption.label}}
                        </mat-checkbox>
                    </div>
                </div>
            </div> 
        </ng-container>
        <!--
        RADIO_GROUP
        -->
        <ng-container *ngIf="type=='RADIO_GROUP'">
            <div class="fieldset"
                [ngClass]="{'outline': true,
                            'selected': editMode}">
                <span class="floating-label"
                    [ngClass]="{'outline': true, 
                                'selected': editMode}">
                    {{label|translate}}
                </span>
                <mat-radio-group aria-label="TBD" 
                                 class="items-container" 
                                 [ngClass]="{'outline': true}">
                    <mat-radio-button *ngFor="let selectableOption of selectableOptions" 
                                      [checked]="isRadioButtonChecked(selectableOption)"
                                      (change)="onOptionChange(selectableOption.id)"
                                      (focusin)="onFormFieldFocus()"
                                      (focusout)="onFormFieldBlur()"
                                      [disabled]="readOnly">
                        {{selectableOption.label}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </ng-container>
        <!--
        CHECKBOX_TREE
        -->
        <ng-container *ngIf="type=='CHECKBOX_TREE'">
            <div class="fieldset" 
                [ngClass]="{'outline': true, 
                            'selected': editMode}">
                <span class="floating-label"
                    [ngClass]="{'outline': true, 
                                'selected': editMode}">
                    {{label|translate}}
                </span>
                <app-checkbox-tree #checkboxTree
                                   [selectableOptions] = "selectableOptions"
                                   [selection] = "checkboxTreeSelection"
                                   (selectionChange)="onCheckboxTreeSelectionChange($event)">
                </app-checkbox-tree>
            </div>
        </ng-container>
        <!--
        SLIDE_TOGGLE
        -->
        <ng-container *ngIf="type=='SLIDE_TOGGLE'">
            <div style="min-height: 58px;" class="layout horizontal middle left">
                <mat-slide-toggle [checked]="!!value"
                                  (change)="onToggle($event.checked)"
                                  [disabled]="readOnly">{{label|translate}}
                </mat-slide-toggle>
            </div>
        </ng-container>
        <!--
        CHECKBOX
        -->
        <ng-container *ngIf="['CHECKBOX','ACKNOWLEDGEMENT_CHECKBOX'].includes(type)">
            <div style="min-height: 58px;" class="layout horizontal middle left">
                <mat-checkbox [checked]="!!value"
                              (change)="onToggle($event.checked)"
                              [disabled]="readOnly">
                    <span style="white-space:normal; display:block; line-height: 1.2;">{{label|translate}}</span>
                </mat-checkbox>
                <!-- <mat-hint *ngIf="isFormFieldHintToBeShown()">{{error && toBeValidated ? (error | translate) : (hint | translate)}}</mat-hint> -->
            </div>
        </ng-container>
    </ng-container>
</div>